var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlertDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 18.333,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 3.667C11.916 3.667 3.666 11.917 3.666 22c0 10.083 8.25 18.333 18.334 18.333 10.083 0 18.333-8.25 18.333-18.333 0-10.083-8.25-18.333-18.333-18.333zm7.7 15.216-8.8 8.8c-.733.734-1.833.734-2.567 0L14.3 23.65c-.734-.733-.734-1.833 0-2.567.733-.733 1.833-.733 2.566 0l2.75 2.75 7.517-7.516c.733-.734 1.834-.734 2.567 0 .733.733.733 1.833 0 2.566z",
    fill: "#24DE9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertDone);
export default __webpack_public_path__ + "static/media/IconAlertDone.18f2d786bba2ffd7fded77348ade9e3f.svg";
export { ForwardRef as ReactComponent };